/**
 * Returns whether the given key is a key of the given object.
 */
export function isKeyOfObject<T extends object>(
  key: string | number | symbol | undefined,
  obj: T,
): key is keyof T {
  return !!key && key in obj;
}
